import scenarios from '../data/scenarios.json';

// Human-written English copy for the training scenarios (name, title, description).
// Stored records keep the original Chinese title, so screens that show saved data map it back
// to English through localizeScenarioTitle().
export const ENGLISH_SCENARIOS = {
  case15: {
    name: 'Mrs. Chen',
    title: 'Routine Check-in with a Homemaker (Phone)',
    description: 'Customer profile:\n- Name: Mrs. Chen\n- Age: 60, female\n- Background: Homemaker\n\nGoal: Understand the customer\'s needs, build trust, and arrange a branch visit.'
  },
  case20: {
    name: 'Mr. Wu',
    title: 'Routine Check-in with a Retired Junior High Teacher (Phone)',
    description: 'Customer profile:\n- Name: Mr. Wu\n- Age: 60, male\n- Background: Retired junior high school teacher\n\nGoal: Understand the customer\'s needs and arrange a branch visit to demonstrate the app.'
  },
  case18: {
    name: 'Mrs. Lee',
    title: 'Portfolio Update for a Homemaker (Phone)',
    description: 'Customer profile:\n- Name: Mrs. Lee\n- Age: 58, female\n- Background: Homemaker\n\nGoal: Provide an account update, discuss education expenses for her grandchildren, and arrange a meeting.'
  },
  case17: {
    name: 'Mrs. Lin',
    title: 'Portfolio Update for a Homemaker (Phone)',
    description: 'Customer profile:\n- Name: Mrs. Lin\n- Age: 58, female\n- Background: Homemaker\n\nGoal: Provide an account update, help the customer consider retirement needs, and arrange a meeting.'
  },
  case19: {
    name: 'Mrs. Tseng',
    title: 'Portfolio Update for a Landlord (Phone)',
    description: 'Customer profile:\n- Name: Mrs. Tseng\n- Age: 58, female\n- Background: Homemaker and landlord\n\nGoal: Provide an account update, discuss her child\'s business plans, and arrange a meeting.'
  },
  case10: {
    name: 'Yu Yang',
    title: 'Personal Loan Offer (E-Life Store Manager)',
    description: 'Customer profile:\n- Name: Yu Yang\n- Age: 45, male\n- Occupation: E-Life store manager\n\nGoal: Introduce the personal loan offer and secure an opportunity for an assessment.'
  },
  case11: {
    name: 'Chuang Hai',
    title: 'Personal Loan Offer (Inventec Engineer)',
    description: 'Customer profile:\n- Name: Chuang Hai\n- Age: 40, male\n- Occupation: R&D engineer at Inventec\n\nGoal: Introduce the exclusive offer and secure an opportunity for an assessment.'
  },
  case12: {
    name: 'Jin Xiang',
    title: 'Personal Loan Offer (San Fang Chemical Industry)',
    description: 'Customer profile:\n- Name: Jin Xiang\n- Age: 35, female\n- Occupation: Employee at San Fang Chemical Industry\n- Current situation: Union Bank loan with monthly payments of about NT$19,000\n\nGoal: Introduce the personal loan offer and secure an opportunity for an assessment.'
  },
  case13: {
    name: 'Jiang Hao',
    title: 'Personal Loan Offer (NCSIST Researcher)',
    description: 'Customer profile:\n- Name: Jiang Hao\n- Age: 42, female\n- Occupation: Researcher at the National Chung-Shan Institute of Science and Technology\n- Current situation: Union Bank loan with monthly payments of about NT$19,000\n\nGoal: Introduce the personal loan offer and secure an opportunity for an assessment.'
  },
  case14: {
    name: 'Principal Huang',
    title: 'Retirement Portfolio Update for a High School Principal (Phone)',
    description: 'Customer profile:\n- Name: Principal Huang\n- Age: 58, male\n- Background: Retired high school principal\n\nGoal: Provide an account update, understand his child\'s business funding needs, and arrange a meeting.'
  },
  case16: {
    name: 'Mr. Tsai',
    title: 'Retirement Portfolio Update for a Former TSMC Manager (Phone)',
    description: 'Customer profile:\n- Name: Mr. Tsai\n- Age: 60, male\n- Background: Retired TSMC manager and landlord\n\nGoal: Provide an account update, understand his child\'s business funding needs, and arrange a meeting.'
  },
  case8: {
    name: 'Lin Chien-kuo',
    title: 'Portfolio Update for a Retired Civil Servant (Phone)',
    description: 'Customer profile:\n- Name: Lin Chien-kuo\n- Age: 57, male\n- Background: Retired civil servant\n\nGoal: Provide an account update, build trust, and arrange a meeting.'
  }
};

const TITLE_PREFIX = /^(\[[A-Z]+\]\s*)/;
// English speaking practice titles are saved as "[ENGLISH] <title> · B1".
const LEVEL_SUFFIX = /(\s*·\s*[A-C][12])$/;

// Practice scenarios that are not in scenarios.json (served by their own API modules).
const EXTRA_SCENARIO_TITLES = {
  'english-app-launch': { zh: '跨國 App 上線進度會議', en: 'Global App Launch Status Meeting' }
};

/**
 * English title for a saved scenario title in the English UI.
 * Looks up by scenario id first, then by the original Chinese title, keeping prefixes such as
 * "[LIVE] " and level suffixes such as " · B1". Unknown scenarios fall back to the stored title.
 */
export const localizeScenarioTitle = (title, scenarioId, isEnglish) => {
  if (!isEnglish) return title;
  const byId = ENGLISH_SCENARIOS[scenarioId]?.title || EXTRA_SCENARIO_TITLES[scenarioId]?.en;
  if (typeof title !== 'string') return byId || title;
  const prefix = title.match(TITLE_PREFIX)?.[1] || '';
  const rest = title.slice(prefix.length).trim();
  const suffix = rest.match(LEVEL_SUFFIX)?.[1] || '';
  const bare = rest.slice(0, rest.length - suffix.length).trim();
  const match = scenarios.find((scenario) => scenario.title === bare);
  const extra = Object.values(EXTRA_SCENARIO_TITLES).find((entry) => entry.zh === bare);
  const english = byId || (match && ENGLISH_SCENARIOS[match.id]?.title) || extra?.en;
  return english ? `${prefix}${english}${suffix}` : title;
};
